import { Award, ShieldCheck, Trophy, Sparkles, Building, Users } from "lucide-react";

const TrustBadges = () => {
    const badges = [
        { Icon: ShieldCheck, label: "IL-Compliant", sub: "TRS · IMRF · SOPPA · BIPA", source: "K12 ERP" },
        { Icon: Building, label: "Municipal Partner", sub: "Town of Aurora, IL", source: "Destination Aurora" },
        { Icon: Trophy, label: "Best In STEM™", sub: "Top 5% Worldwide", source: "STEM.org · RSS" },
        { Icon: Award, label: "Accredited™", sub: "Dual Trustmark", source: "STEM.org · RSS" },
        { Icon: Sparkles, label: "501(c)(3)", sub: "Non-Profit Sponsor", source: "APS Training Academy" },
        { Icon: Users, label: "14+ Years", sub: "Shipping since 2011 · AI/ML since 2019", source: "APS Data Technologies" },
    ];

    return (
        <section className="relative py-24 border-t border-white/5">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="text-center mb-14">
                    <div className="text-[11px] font-mono uppercase tracking-widest text-accent-brand mb-4">
                        / Credentials
                    </div>
                    <h2 className="text-4xl md:text-5xl font-display text-white leading-tight tracking-tight">
                        Trusted where <em className="italic text-white/50">outcomes matter.</em>
                    </h2>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/10">
                    {badges.map((b, i) => (
                        <div
                            key={i}
                            className="bg-ink-950 p-6 flex flex-col items-center text-center gap-2 hover:bg-ink-900 transition-colors"
                            data-testid={`trust-badge-${i}`}
                        >
                            <div className="w-10 h-10 rounded-full bg-accent-brand/10 flex items-center justify-center mb-2">
                                <b.Icon className="w-5 h-5 text-accent-brand" strokeWidth={1.5} />
                            </div>
                            <div className="text-white text-sm font-semibold">{b.label}</div>
                            <div className="text-white/50 text-xs">{b.sub}</div>
                            <div className="text-[10px] font-mono uppercase tracking-widest text-white/25 mt-1">
                                {b.source}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TrustBadges;
